import { Box, Button, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

interface ButtonProps {
  title?: string;
  loading?: boolean;
  width?: string;
  height?: string;
  color?: string;
  bgColor?: string;
  fSize?: string;
  icon1?: JSX.Element | boolean;
  icon2?: JSX.Element | boolean;
  border?: string;
  borderColor?: string;
  boxShadow?: string;
  px?: string;
  py?: string;
  borderRadius?: string;
  mt?: string;
  mr?: string;
  mb?: string;
  onClick?: () => void;
  fontWeight?: number;
  justifyContent?: string;
  flexDirection?: string;
  disabled?: boolean;
  notAllow?: boolean;
  disableRipple?: boolean;
  disableShadow?: boolean;
  invertX?: boolean;
  type?: "outlined" | "contained";
  textColor?: string;
}

const CustomButton = (props: ButtonProps) => {
  const {
    textColor = "#ffffff",
    type = "contained",
    title = "ورود",
    loading = false,
    width = "auto",
    height = "auto",
    color = "lightStatic.main",
    bgColor = "primary.main",
    fSize = "14px",
    icon1,
    icon2,
    border = "none",
    borderColor = "lightStatic.main",
    boxShadow = "none",
    px = "10px",
    py = "10px",
    borderRadius = "10px",
    mt = "0px",
    mr = "0px",
    mb = "0px",
    onClick,
    fontWeight = "400",
    justifyContent = "center",
    flexDirection = "space-between",
    disabled = false,
    notAllow = false,
    disableRipple = false,
    disableShadow = false,
    invertX = false,
  } = props;

  return (
    <Button
      variant={type}
      onClick={onClick}
      // disabled={disabled}
      disableRipple={disableRipple}
      disableElevation={disableShadow}
      startIcon={loading && <CircularProgress size={24} color="inherit" />}
      sx={{
        lineHeight: "normal",
        display: "flex",
        justifyContent: justifyContent,
        flexDirection: flexDirection,
        gap: "6px",
        width: width,
        minWidth: width,
        height: height,
        bgcolor: loading && type === "outlined" ? borderColor : bgColor,
        fontSize: fSize,
        px: px,
        py: py,
        color: color,
        // border: border,
        borderColor: borderColor,
        borderWidth: "1px",
        borderStyle: disabled ? "solid" : "",
        boxShadow: boxShadow,
        borderRadius: borderRadius,
        mt: mt,
        mr: mr,
        mb: mb,
        fontWeight: fontWeight,
        cursor: notAllow ? "not-allowed" : "pointer",

        "&.MuiButtonBase-root:hover": {
          bgcolor: loading && type === "outlined" ? borderColor : bgColor,
          borderColor: type === "contained" ? "" : borderColor,
          border: type === "outlined" ? borderColor : "",
          // borderWidth: "2px",
          // borderStyle: "solid",
          // borderColor: type === "outlined" ? borderColor : "",
          opacity: 0.92,
        },
      }}
    >
      {/* {icon1 && (
        <Box
          sx={{
            textAlign: "left",
            mx: title ? "6px" : "0px",
            "& svg": {
              transform: invertX ? "scaleX(-1)" : "none",
            },
          }}
        >
          {icon1}
        </Box>
      )} */}

      {!loading && (
        <>
          <Box
            sx={{
              display: "flex",
              gap: "6px",
              alignItems: "center",
            }}
          >
            {icon1 && icon1}
            <Typography
              noWrap
              sx={{
                color: textColor,
              }}
            >
              {title && title}
            </Typography>
          </Box>
          {icon2 && <Box>{icon2}</Box>}
        </>
      )}
    </Button>
  );
};

export default CustomButton;
